<template>
    <div>
      <v-card>
        <v-card-text>
            <v-row>
                <h2>Family Member Export</h2>
            </v-row>

          <!-- Previous export option (month/year based) — commented out -->
          <!--
          <v-row>
            <v-col lg="4">
                  <label>Enroll Nominated Month</label>
                  <v-select
                    class="mr-1"
                    :items="s_export_months"
                    v-model="month"
                    item-text="text"
                    :error-messages="monthValidation"
                    item-value="value"
                    dense
                    outlined
                  ></v-select>
                </v-col>
                <v-col  lg="4">
                  <label>Enroll Nominated Year</label>
                  <v-select
                    class="mr-1"
                    :items="years"
                    v-model="year"
                    item-text="text"
                    item-value="value"
                    :error-messages="yearValidation"
                    dense
                    outlined
                  ></v-select>
                </v-col>
            <v-col lg="4">
                <v-card-actions>
                    <v-btn class="form-btn" @click="exportData"  :loading="loading">
                        <v-icon left>mdi-chevron-right-circle-outline</v-icon>Export
                    </v-btn>
                </v-card-actions>
            </v-col>
          </v-row>
          -->

          <!-- Search type selection -->
          <v-row class="mt-2">
            <v-col>
              <v-radio-group v-model="searchType" row hide-details>
                <v-radio label="Treatment Start Date" value="treatment"></v-radio>
                <v-radio label="Support Start Date" value="support"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>

          <!-- Treatment Start Date option -->
          <v-row v-if="searchType === 'treatment'" align="center">
            <v-col lg="4">
              <label>Treatment Start Date (From)</label>
              <v-text-field
                v-model="treatmentFrom"
                type="date"
                dense
                outlined
                hide-details
              ></v-text-field>
            </v-col>
            <v-col lg="4">
              <label>Treatment Start Date (To)</label>
              <v-text-field
                v-model="treatmentTo"
                type="date"
                dense
                outlined
                hide-details
              ></v-text-field>
            </v-col>
            <v-col lg="4">
              <v-card-actions>
                <v-btn class="form-btn" @click="exportData" :loading="loading">
                  <v-icon left>mdi-chevron-right-circle-outline</v-icon>Export
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>

          <!-- Support Start Date option -->
          <v-row v-if="searchType === 'support'" align="center">
            <v-col lg="4">
              <label>Support Start Date (From)</label>
              <v-text-field
                v-model="supportFrom"
                type="date"
                dense
                outlined
                hide-details
              ></v-text-field>
            </v-col>
            <v-col lg="4">
              <label>Support Start Date (To)</label>
              <v-text-field
                v-model="supportTo"
                type="date"
                dense
                outlined
                hide-details
              ></v-text-field>
            </v-col>
            <v-col lg="4">
              <v-card-actions>
                <v-btn class="form-btn" @click="exportData" :loading="loading">
                  <v-icon left>mdi-chevron-right-circle-outline</v-icon>Export
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>

        </v-card-text>

      </v-card>
    </div>
  </template>

  <script>
  import { mapState } from "vuex";
  export default {
    components: {},
    data: () => ({
      loading: null,
      searchType: "treatment",
      treatmentFrom: null,
      treatmentTo: null,
      supportFrom: null,
      supportTo: null,
      // Previous fields — kept for reference
      // month: null,
      // year: null,
    }),

    computed: {
        ...mapState("Admin", ["admin"]),
      ...mapState("Loading", ["loading"]),
      ...mapState("Township", ["townships"]),
      ...mapState("TownshipGroup", ["townshipGroups"]),
      ...mapState("InitialData", ["s_export_months", "years"]),
    },
    methods: {
      exportData() {
        let data = {
          township_group_id: this.admin?.township_group_id,
        };

        if (this.searchType === "treatment") {
          if (!this.treatmentFrom || !this.treatmentTo) {
            alert("Please fill in both Treatment Start Date fields.");
            return false;
          }
          data.type = "treatment";
          data.from_date = this.treatmentFrom;
          data.to_date = this.treatmentTo;
        } else {
          if (!this.supportFrom || !this.supportTo) {
            alert("Please fill in both Support Start Date fields.");
            return false;
          }
          data.type = "support";
          data.from_date = this.supportFrom;
          data.to_date = this.supportTo;
        }

        this.loading = true;
        this.$store
          .dispatch("Presumptive/familymembergetExport", data)
          .then(() => (this.loading = false));
      },
    },
    created() {
    //   this.$store.dispatch("Township/getTownships");
      this.$store.dispatch("TownshipGroup/getTownshipGroups");
    },
  };
  </script>

  <style scoped></style>
